module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\">\r\n    <path stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n    <text font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n      <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n    </text>\r\n  </g>\r\n</svg>\r\n"


//////////////////
// WEBPACK FOOTER
// ./template/styles/icons/notification.svg
// module id = ./template/styles/icons/notification.svg
// module chunks = client.sitechrome